import React, { useContext } from 'react';
import ActionMenuDropdown from '@/components/ActionMenuDropdown/ActionMenuDropdown';
import { modalContext } from '@/context/modal.context';
import { toastContext } from '@/context/toast.context';
import { viewportContext } from '@/context/viewport.context';
import useMixpanel from '@/hooks/useMixpanel';
import { copyShareLink, openFacebookShare, trackSharedResource } from '@/utils/sharer';
import t from '@/utils/Language/ShareResourceDropdown-translations';
import classes from './ShareResourceDropdown.module.scss';

const ShareResourceDropdown = ({
  resource,
  buttonStyles,
  additionalClasses,
  project,
  shareType,
  inviteType,
  inviteValue,
  inviteIsReusable,
  shareData
}) => {
  const { enqueueModal } = useContext(modalContext);
  const { addToast } = useContext(toastContext);
  const { isMobileOrTablet } = useContext(viewportContext);
  const menuClass = isMobileOrTablet ? classes.mobileShareResourceItem : classes.shareResourceItem;
  const { track } = useMixpanel();

  const menuList = [
    { key: 'email', icon: { style: 'fas', font: 'envelope' }, text: t('Email'), classes: menuClass },
    { key: 'sms', icon: { style: 'fas', font: 'mobile-alt' }, text: t('Text message'), classes: menuClass }
  ];

  const additionalMenuList = [
    { key: 'facebook', icon: { style: 'fab', font: 'facebook-square' }, text: t('Facebook'), classes: menuClass },
    { key: 'copy', icon: { style: 'fas', font: 'link' }, text: t('Copy link'), classes: menuClass }
  ];

  const closeMenu = [{ key: 'close', icon: { style: 'fas', font: 'times' }, text: t('Close'), classes: menuClass }];

  const onSelect = (eventKey) => {
    switch (eventKey) {
      case 'email':
      case 'sms':
        enqueueModal({
          name: 'ShareResourceModal',
          method: eventKey,
          resource,
          project,
          inviteType,
          inviteValue,
          inviteIsReusable,
          shareType,
          shareData
        });
        break;
      case 'facebook':
        trackSharedResource(track, resource, eventKey);
        openFacebookShare();
        break;
      case 'copy':
        trackSharedResource(track, resource, eventKey);
        if (copyShareLink(resource)) {
          addToast({
            message: t('Link copied to your clipboard.'),
            delay: 3000,
            type: 'success'
          });
        }
        break;
      case 'close':
        // do nothing, the dropdown closes automatically when an option is selected
        break;
    }
  };
  return (
    <ActionMenuDropdown
      buttonStyles={
        buttonStyles || {
          buttonType: 'secondary',
          buttonShape: 'rounded',
          buttonText: isMobileOrTablet ? '' : t('Share'),
          buttonBorder: true,
          buttonIcon: { style: 'fas', font: 'share-square' }
        }
      }
      additionalClasses={additionalClasses}
      menuList={shareType === 'allResult' ? [...menuList, ...closeMenu] : [...menuList, ...additionalMenuList, ...closeMenu]}
      onSelect={onSelect}
    />
  );
};

export default ShareResourceDropdown;
